import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Sidebar from "../dashboardLayout/sidebar/Sidebar";
import SidePanelContainer from "./SidePanelContainer";
import { useState } from "react";
import { faBars } from "@fortawesome/free-solid-svg-icons";


function RightSideBarPanel() {
  const [openModule, setOpenModule] = useState(false);

  return (
    <>
      <button
        className="btn btn-link p-0 hamburger-btn text-theme"
        onClick={() => setOpenModule(true)}
        aria-label="Open filters"
      >
        <FontAwesomeIcon icon={faBars} size="45" className="text-theme" />
      </button>

      <SidePanelContainer
        title="Menu"
        width="200px"
        openModule={openModule}
        setOpenModule={setOpenModule}
      >
        <Sidebar />
      </SidePanelContainer>
    </>
  );
}

export default RightSideBarPanel;
